<template>
  <div v-if="loggedIn" class="shadow dropmenu">
      <div v-for="report in getReports" :key="report.reportId" class="pb-1">
        <b-dropdown-item :to="{name: 'report', params:{reportId: report.reportId}}">{{report.name}}</b-dropdown-item>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dropdown",
  props: {
    group: {
      type: Object,
      required: true
    }
  },
  computed: {
    loggedIn() {
      return this.$store.getters.loggedIn;
    },
    getReports() {
      return this.$store.getters.getReports.filter(
        report => report.groupId === this.group.groupId
      );
    }
  },
  created() {
    if (
      this.$store.getters.getReports.filter(
        report => report.groupId === this.group.groupId
      ).length === 0
    ) {
      this.$store.dispatch("retrieveReports", this.group.groupId);
    }
  }
};
</script>

<style>
.dropdown-menu {
  outline: none;
  border: none;
}
</style>